import {
  context,
  tiny_invariant_esm_default,
  useContext
} from "./chunk.IOTCVWDR.js";

// node_modules/react-router/esm/react-router.js
function useLocation() {
  if (process.env.NODE_ENV !== "production") {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? tiny_invariant_esm_default(false, "You must use React >= 16.8 in order to use useLocation()") : tiny_invariant_esm_default(false) : void 0;
  }
  return useContext(context).location;
}

export {
  useLocation
};
